import axios from 'axios';
import Swal from 'sweetalert2';
import { forEach } from 'lodash';

class HandleDestroyRequest {
  constructor() {
    this.method = null;
    this.url = null;
  }

  bind() {
    forEach(window.document.querySelectorAll('a[data-method]'), item => {
      item.addEventListener('click', e => {
        this.handle(e, item);
      });
    });
  }

  handle(e, item) {
    e.preventDefault();

    const method = item.dataset.method.toLowerCase();

    Swal.fire({
      title: 'Are you sure?',
      text: 'You wound not be able to revert this!',
      type: 'warning',
      reverseButtons: true,
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonColor: '#03a9f4',
      confirmButtonClass: 'button is-primary',
      cancelButtonClass: 'button is-danger is-medium',
      cancelButtonColor: '#f44336',
      preConfirm() {
        return new Promise(resolve => {
          axios[method](item.href, { _method: method })
            .then(() => {
              resolve();
            })
            .catch((error) => {
              if (error?.response?.data?.message) {
                Swal.showValidationMessage(error.response.data.message);
              } else {
                Swal.showValidationMessage('Please try again');
              }
            });
        });
      }
    })
      .then((result) => {
        if (result.value) {
          location.reload();
        }
      })
      .catch(() => {});
  }
}

export default new HandleDestroyRequest();
